module.exports = __webpack_public_path__ + "static/media/20.6130c5be.jpeg";